import React from "react";
import {Tooltip} from "flowbite-react";
import FeatureLaneButton from "./button";
import {DeliverableGroupKey, FeatureLaneModelWithStatus} from "data/models/feature-lane";

export type FeatureLaneProps = FeatureLaneModelWithStatus & {
  deliverableGroupId: DeliverableGroupKey,
};

export default function FeatureLane(
    {
      id: featureId,
      deliverableGroupId,
      userSurveys,
    }: FeatureLaneProps
) {
  return <div className={"max-w-screen-lg flex flex-col my-4 md:mx-48 mx-0 grow items-center"}>
    <div className={"relative flex flex-row"}>
      <div className={"absolute w-full h-full"}>
        <div className={"relative top-6 w-full h-1.5 bg-neutral-50"}></div>
      </div>
      <div className={"grow flex flex-row justify-center px-3 z-10"}>
        {userSurveys.map(
            (userSurvey, index) => <div className={"flex flex-col items-center mx-4"} key={userSurvey.id}>
              <Tooltip content={<>{userSurvey.title}{userSurvey.statusReason !== null && <><br/>{userSurvey.statusReason}</>}</>} >
                <div className={"flex flex-row justify-center bg-white md:w-28 md:mx-4 w-8 mx-1"}>
                  <FeatureLaneButton
                      deliverableGroupId={deliverableGroupId}
                      featureId={featureId}
                      userSurvey={userSurvey}
                  />
                </div>
                <div className={"w-28 mx-4 mt-2 text-center md:block hidden"}>
                  {<span className={"text-neutral-500 text-sm"}>{userSurvey.title}</span>}
                </div>
              </Tooltip>
            </div>
        )}</div>
    </div>
  </div>
}
